// Firebase — Admin Hub 認証専用（synapseadminhub Google ログイン）
// 設定値は .env の VITE_ADMIN_HUB_* から読み込み（ハードコードなし）

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const REQUIRED_ENV_KEYS = [
  'VITE_ADMIN_HUB_API_KEY',
  'VITE_ADMIN_HUB_AUTH_DOMAIN',
  'VITE_ADMIN_HUB_PROJECT_ID',
  'VITE_ADMIN_HUB_STORAGE_BUCKET',
  'VITE_ADMIN_HUB_MESSAGING_SENDER_ID',
  'VITE_ADMIN_HUB_APP_ID'
];

function readRequiredEnv(key) {
  const value = import.meta.env[key];
  if (!value || String(value).trim() === '') {
    return { key, value: null };
  }
  return { key, value: String(value).trim() };
}

const envValues = REQUIRED_ENV_KEYS.map(readRequiredEnv);
const missing = envValues.filter((entry) => !entry.value).map((entry) => entry.key);

if (missing.length > 0) {
  throw new Error(
    `Firebase 設定が不足しています。.env に以下を設定してください: ${missing.join(', ')}`
  );
}

const adminHubFirebaseConfig = {
  apiKey: envValues[0].value,
  authDomain: envValues[1].value,
  projectId: envValues[2].value,
  storageBucket: envValues[3].value,
  messagingSenderId: envValues[4].value,
  appId: envValues[5].value
};

const adminHubApp = initializeApp(adminHubFirebaseConfig, 'adminHub');
const adminHubAuth = getAuth(adminHubApp);

export { adminHubApp, adminHubAuth };

export default adminHubApp;
